import { Button, Stack, Typography } from "@mui/material";
import { type FC } from "react";
import { useNavigate } from "react-router";

import { ROUTES } from "~/constants/routing";

import styles from "./NotFoundPage.module.scss";

export const NotFoundPage: FC = () => {
  const navigate = useNavigate();

  return (
    <main className={styles.root}>
      <Typography variant="h3" component="h1" sx={{
        fontWeight: 600
      }}>
        Page not found
      </Typography>
      <Typography
        align="center"
        sx={{
          paddingLeft: 3,
          paddingRight: 3
        }}>
        The market you’re looking for may have been removed, resolved, or never
        existed.
      </Typography>
      <Stack
        sx={{
          flexDirection: "row",
          gap: 2,
          marginTop: 6
        }}>
        <Button
          variant="outlined"
          color="primary"
          onClick={() => navigate(ROUTES.main.createURL())}
        >
          Go Home
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={() => navigate(ROUTES.highlights.createURL())}
        >
          Browse Highlights
        </Button>
      </Stack>
    </main>
  );
};
